import { ScheduleGlobalResponseTypes } from "backend";
import { Requests } from "../common/request.common";
import { post } from "./common";

export const scheduleGlobal = {
    record(data: typeof Requests.ScheduleGlobal.Record.Input) {
        return post<typeof data, ScheduleGlobalResponseTypes.Record>(
            "/schedule-global/record",
            data,
        );
    },
    create(data: typeof Requests.ScheduleGlobal.Create.Input) {
        return post<typeof data>("/schedule-global/create", data);
    },
    update(id: string, data: typeof Requests.ScheduleGlobal.Update.Input) {
        return post<typeof data>(`/schedule-global/update/${id}`, data);
    },
};
